/**
 * `POST /api/cart/sync-login` builder — merge guest cart into authenticated
 * user cart. Returns the parsed `{ success: true }` envelope; the cart
 * provider wraps the call inside a dedup helper that needs a JSON return
 * value, so we surface it instead of resolving to `void`.
 *
 * @see packages/contract/src/cart-sync-login.ts — contract
 * @see app/api/cart/sync-login/route.ts — handler
 */

import {
  parseApiResponse,
  CartSyncLoginResponseSchema,
  type CartSyncLoginRequest,
  type CartSyncLoginResponse,
} from "@kraahl/contract";

export interface SyncLoginCartArgs {
  userId: string;
  guestId: string;
  signal?: AbortSignal;
}

export async function syncLoginCart(
  args: SyncLoginCartArgs,
): Promise<CartSyncLoginResponse> {
  const body: CartSyncLoginRequest = {
    guestId: args.guestId,
    userId: args.userId,
  };

  const res = await fetch("/api/cart/sync-login", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
    ...(args.signal ? { signal: args.signal } : {}),
  });

  if (!res.ok) {
    throw new Error(`Sync login failed: ${res.status}`);
  }

  return parseApiResponse(res, CartSyncLoginResponseSchema);
}
